import { adminApi } from '../../api/endpoints'
import { BulkImportPage, Column, type BulkImportConfig } from './BulkImportPage'

/**
 * Bulk tutor sign-up.
 *
 * <p>The same page as the student import - see {@link BulkImportPage} - with the one difference a
 * provider's file has: no date of birth, because a tutor's age has no bearing on anything the
 * platform gates. Every other column, including gender and the location/category block, means the
 * same thing on this side of the marketplace as it does on the student one.
 */
const CONFIG: BulkImportConfig = {
  title: 'Bulk tutor sign-up',
  intro:
    'Upload a CSV and YellowDots creates a draft account per row - no email is sent and no dot ' +
    'appears yet - unless you tick "Email everyone" below. Otherwise, when you are ready, open the ' +
    'Report status tab, tick who to invite and press Send ' +
    'invitation; each tutor becomes live once they confirm.',
  noun: 'tutor',
  nounPlural: 'tutors',
  templateFilename: 'yellow-dot-tutors.csv',
  columns: (
    <>
      <Column name="full_name" required>the tutor's name</Column>
      <Column name="email" required>where the set-password link goes</Column>
      <Column name="phone" required>ten digits, +91 and spaces are fine</Column>
      <Column name="gender" required>MALE, FEMALE, OTHER, PREFER_NOT_TO_SAY</Column>
      <Column name="address">the full street address - optional</Column>
      <Column name="city" required>e.g. Delhi</Column>
      <Column name="state" required>e.g. Delhi</Column>
      <Column name="pincode" required>six digits, used to place them on the map</Column>
      <Column name="category" required>
        what they offer - academics, competitive_exams, music, sports, arts, skills, ai,
        languages, school_admission, higher_education or internships
      </Column>
      <Column name="sub_category">
        the specific item within that category, e.g. Mathematics - optional, and must be one of
        the category's own items when given
      </Column>
    </>
  ),
  notice:
    'Everyone in this file is taken as already checked: they are created verified, and given the ' +
    'service row their category and ' +
    'sub-category name, so they are findable straight away. They skip the verification queue ' +
    'entirely, so upload only people ops has actually vetted. Their bio and qualifications stay ' +
    'theirs to add once they have set a password.',
  upload: (file, dryRun, onLine, sendInvites) => adminApi.importTutors(file, dryRun, onLine, sendInvites),
  downloadTemplate: () => adminApi.tutorImportTemplate(),
}

export function AdminTutorImportPage() {
  return <BulkImportPage config={CONFIG} />
}
